interface Branch {
  id: string;
  name: string;
}

interface BranchSelectorProps {
  branches: Branch[];
  selected: string[];
  onChange: (selected: string[]) => void;
  label?: string;
}

export default function BranchSelector({ branches, selected, onChange, label }: BranchSelectorProps) {
  const toggle = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter((s) => s !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div>
      {label && <label>{label}</label>}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 6 }}>
        {branches.map((b) => (
          <label
            key={b.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 10px",
              borderRadius: "var(--radius-sm)",
              border: "1px solid var(--border)",
              background: selected.includes(b.id) ? "var(--accent-dim)" : "var(--bg-elevated)",
              color: selected.includes(b.id) ? "var(--accent)" : "var(--text)",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 400,
            }}
          >
            <input
              type="checkbox"
              checked={selected.includes(b.id)}
              onChange={() => toggle(b.id)}
              style={{ accentColor: "var(--accent)", cursor: "pointer" }}
            />
            {b.name}
          </label>
        ))}
      </div>
    </div>
  );
}
